import { EmailSelectTemplateToTestOptionValue } from '../../../EmailSelectTemplateToTestVariablesModal'

export const EXTERNAL_VARIABLES_API_KEY = {
  [EmailSelectTemplateToTestOptionValue.googleTemplate]: 'external_variables',
  [EmailSelectTemplateToTestOptionValue.textTemplate]: 'undefined_variables',
}
